/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const GetDetailsOfCurrentUser = /* GraphQL */ `
  query GetDetailsOfCurrentUser($input: GetDetailsOfCurrentUserInput) {
    GetDetailsOfCurrentUser(input: $input)
  }
`;
export const ListAllCustomerDetailsToRespectiveProjectManager = /* GraphQL */ `
  query ListAllCustomerDetailsToRespectiveProjectManager(
    $input: ListAllCustomerDetailsToRespectiveProjectManagerInput
  ) {
    ListAllCustomerDetailsToRespectiveProjectManager(input: $input)
  }
`;
export const ListProjectsOfCustomers = /* GraphQL */ `
  query ListProjectsOfCustomers($input: ListProjectsOfCustomersInput!) {
    ListProjectsOfCustomers(input: $input)
  }
`;
export const ListAllCustomers = /* GraphQL */ `
  query ListAllCustomers($input: ListAllCustomersInput!) {
    ListAllCustomers(input: $input)
  }
`;
